import { Layout, Drawer, Row, Button, Card, Col } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { FC, useEffect, useState } from 'react';
import { RiCloseFill, RiMenuFill } from 'react-icons/ri';
import {
  selectEvent,
  updateEvent,
  addEvent,
  removeEvent,
} from '../../../../redux/calendar/calendarActions';
import store from '../../../../redux/store';
import AddEventSidebar from '../../../apps/calendar/AddEventSidebar';
import { useSelector } from 'react-redux';
import { Calendar } from './calendar';
import { QueriedData } from '../../assets/useAssets';
import { AggregatedBooking } from '../useBookings';
import { CalendarApi } from '@fullcalendar/react';

export interface Props {
  bookingsQuery: QueriedData<AggregatedBooking[]>;
}
const BookingsCalendar: FC<Props> = ({ bookingsQuery }) => {
  const [calendarApi, setCalendarApi] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDrawervisible, setIsDrawerVisible] = useState(false);

  const showDrawer = () => {
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const customise = useSelector<{customise: any}>((state) => state.customise);
  // Object
  const blankEvent = {
    title: '',
    start: '',
    end: '',
    allDay: false,
    url: '',
    extendedProps: {
      calendar: '',
      guests: [],
      location: '',
      description: '',
    },
  };

  // RefetchEvents
  const refetchEvents = () => {
    if (calendarApi !== null) {
      (calendarApi as CalendarApi).refetchEvents();
    }
  };

  // Fetch Events
  useEffect(() => {}, []);
  return (
    <Layout className='hp-calendar hp-mb-32 hp-bg-dark-90'>
      <Drawer
        title=' '
        className='hp-calendar-mobile-menu'
        placement='left'
        closable={true}
        onClose={closeDrawer}
        open={isDrawervisible}
        closeIcon={
          <RiCloseFill
            className='remix-icon hp-text-color-black-80 hp-text-color-dark-30'
            size={24}
          />
        }
      ></Drawer>

      <Content>
        <Row className='hp-calendar-mobile-menu-btn hp-bg-color-black-0 hp-bg-color-dark-100 hp-border-radius hp-py-12 hp-px-sm-8 hp-px-24 hp-mb-16'>
          <Button
            className='hp-p-0'
            type='text'
            icon={
              <RiMenuFill
                size={24}
                className='remix-icon hp-text-color-black-80 hp-text-color-dark-30'
              />
            }
            onClick={showDrawer}
          />
        </Row>

        <Card>
          <Row>
            <Col flex='1 1' className='hp-py-24'>
              <Calendar
                blankEvent={blankEvent}
                calendarApi={calendarApi}
                selectEvent={selectEvent}
                updateEvent={updateEvent}
                setCalendarApi={setCalendarApi}
                dispatch={() => {}}
                store={{}}
                showModal={showModal}
                bookingsQuery={bookingsQuery}
              />
            </Col>
          </Row>
        </Card>

        <AddEventSidebar
          store={store}
          dispatch={() => {}}
          addEvent={addEvent}
          selectEvent={selectEvent}
          updateEvent={updateEvent}
          removeEvent={removeEvent}
          calendarApi={calendarApi}
          refetchEvents={refetchEvents}
          handleCancel={handleCancel}
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          showModal={showModal}
        />
      </Content>
    </Layout>
  );
};

export default BookingsCalendar;
